export default {
  cont_signed: 'Signed',
  cont_counterparty_name: 'Counterparty name, email or account ID',
  cont_counterparty_email_or_id: 'Counterparty email or account ID',
  cont_contract_number: 'Contract number',
  cont_show_active_disputes: 'Show contracts with active disputed only',
  cont_counterparty: 'Counterparty',
  cont_no_signed_contracts: 'No signed contracts',
  cont_no_signed_contracts_desc: 'Here will be the list of your signed contracts',
  cont_active_disputes: 'Active disputes',
  cont_details: 'Contract details',
  cont_company_id: 'Company account ID',
  cont_new_contract: 'New contract',
  cont_sign_and_send: 'Sign and send',
  cont_sign_and_send_to_counterparty: 'Sign and send to the counterparty',
  cont_signature_requests: 'Signature requests',
  cont_no_archived_contracts: 'No archived contracts',
  cont_no_archived_contracts_desc: 'Here will be the list of your archived contracts',
  cont_no_contract_requests: 'No contract requests',
  cont_no_contract_requests_desc: 'Here will be the list of your contract requests',
  cont_no_invoice_requests: 'No invoice requests',
  cont_no_invoice_requests_desc: 'Here will be the list of your invoice requests',
  cont_invoice_number: 'Invoice number',
  cont_invoice_information: 'Invoice information',
  cont_dispute_information: 'Dispute information',
  cont_appeal_to_escrow: 'Appeal to the Escrow',
  cont_resolve_the_dispute: 'Resolve the dispute',
  cont_start_a_dispute: 'Start a dispute',
  cont_confirm_the_payment: 'Confirm the payment',
  cont_create_invoice: 'Create a new invoice',
  cont_invoices: 'Invoices',
  cont_invoice_amount: 'Amount %{asset}',
  cont_email_invalid: 'Counterparty email is invalid',
  cont_counterparty_invalid: 'Counterparty name is invalid',
  cont_pending_status: 'Pending signature by the counterparty',
  cont_type_outgoing: 'Outgoing',
  cont_type_incoming: 'Incoming',
  cont_sign: 'Sign',
  contract_signed: 'Contract signed',
  contract_rejected: 'Contract rejected',
  contract_completed: 'Contract completed',
  cont_invoice_confirmed: 'Invoice confirmed',
  cont_invoice_rejected: 'Invoice rejected',
  cont_contract_confirmed: 'Contract payments confirmed',
  cont_confirm_completed: 'Confirm completed',
  cont_dispute_submitted: 'Dispute submitted',
  cont_invoice_created: 'Invoice sent',
  cont_appeal_success: 'Appeal to Escrow sent successfully',
  cont_appeal_escrow_by: 'Appeal to the escrow by',
  cont_escrow_resolution: 'Escrow resolution'
}



// WEBPACK FOOTER //
// ./src/js/i18n/views/contact_us.js